import { IconZapbot } from "blocks/components/icons";

export const ZeroState = (props: { title: string; subtitle?: string }) => {
  return (
    <div className="flex flex-col items-center rounded-lg bg-zi-white p-[50px] shadow-subtle">
      <span className="flex h-20 w-20 items-center justify-center rounded-[50%] bg-zi-lightGray text-zi-gray">
        <IconZapbot size={40} color="currentColor" />
      </span>
      <div className="text-center">
        <h4 className="mt-[30px] text-lg font-semibold">{props.title}</h4>
        {props.subtitle && (
          <p className="mt-[18px] text-base text-zi-secondaryText">
            {props.subtitle}
          </p>
        )}
      </div>
    </div>
  );
};
